import { theme as antdTheme } from 'antd';

export const theme = Object.freeze({
	token: {
		colorPrimary: '#6324c8',
	},
	components: {
		Input: {
			controlHeightLG: 45
		},
		InputNumber: {
			controlHeightLG: 45
		},
		Select: {
			controlHeightLG: 45
		},
	},
	algorithm: antdTheme.defaultAlgorithm,
})

// Generator: https://ant.design/theme-editor

// Screen endpoints:
// {
//   xs: '480px',
//   sm: '576px',
//   md: '768px',
//   lg: '992px',
//   xl: '1200px',
//   xxl: '1600px',
// }

export const TRANSACTION_STATUS = Object.freeze({
	NEW: 'new',
	DECLINED: 'declined',
	PENDING: 'pending',
	APPROVED: 'approved',
	DONE: 'done',
});
export const TRANSACTION_TYPE = Object.freeze({
	SEND: 'SEND',
	RECEIVE: 'RECEIVE',
});
export const PAYMENT_SYSTEM = Object.freeze({
	SWIFT: 'SWIFT',
	SEPA: 'SEPA',
});
export const CLIENT_TYPE = Object.freeze({
	INDIVIDUAL: 'individual',
	CORPORATE: 'corporate',
})
